export default "__VITE_ASSET__D8jU1i5r__"